module.exports = __webpack_public_path__ + "static/full03-c57d7bb129419966609ac4692e1f7529.png";